import React, { Component } from 'react';
import './Hvacschedule.css';

class Hvacschedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
     data: []

    }
  }

  // handleUserInput = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   this.props.onOptionsUpdate({
  //     [name]: parseInt(value)
  //   });
  // }

  handleUserInput = (e) => {
    let update ={}; //11-01-18
  
    const set = name => {
      const value = e.target.value;
      update[name] = parseInt(value)
    }
      const name = e.target.name;
      set(name) 
      //restrict user 11-01-18
      if(e.target.type === 'number') {
        const min = parseInt(e.target.getAttribute('min'));
        const max = parseInt(e.target.getAttribute('max'));
        const value = parseInt(e.target.value);
        console.log(min, max, value);
        
        if (value < min || value > max) return false;
      }  //end restrict 11-01-18
      this.props.onOptionsUpdate(update);
    }

  render() {
    return (
      <div>
       <p className="calendar_para"><i class="fas fa-plug  green-icon"></i> <b>HVAC Number Days per Month and Hours per Day</b></p>
       
        <table className="tbl_calendardata">
        <tr>
        <th>Jan</th>
              <th>Feb</th>
              <th>Mar</th>
              <th>Apr</th>
              <th>May</th>
              <th>Jun</th>
              <th>Jul</th>
              <th>Aug</th>
              <th>Sep</th>
              <th>Oct</th>
              <th>Nov</th>
              <th>Dec</th>
            </tr>
          <tr>
            <td>  <label className="App-bold" htmlfor="janHVACCalendar">days:</label>
                  <input type="number"
                    name="janHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.janHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td><label className="App-bold" htmlfor="febHVACCalendar">days:</label>
                  <input type="number"
                    name="febHVACCalendar"
                    min="0"
                    max="28"
                    step="1"
                    value={this.props.options.febHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="marHVACCalendar">days:</label>
                  <input type="number"
                    name="marHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.marHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td>  <label className="App-bold" htmlfor="aprHVACCalendar">days:</label>
                  <input type="number"
                    name="aprHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.aprHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="may">days:</label>
                  <input type="number"
                    name="mayHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.mayHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td><label className="App-bold" htmlfor="junHVACCalendar">days:</label>
                  <input type="number"
                    name="junHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.junHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
                   <td> <label className="App-bold" htmlfor="julHVACCalendar">days:</label>
                  <input type="number"
                    name="julHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.julHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="augHVACCalendar">days:</label>
                  <input type="number"
                    name="augHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.augHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
           
            <td><label className="App-bold" htmlfor="sepHVACCalendar">days:</label>
                  <input type="number"
                    name="sepHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.sepHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="octHVACCalendar">days:</label>
                  <input type="number"
                    name="octHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.octHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="novHVACCalendar">days:</label>
                  <input type="number"
                    name="novHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.novHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
            <td> <label className="App-bold" htmlfor="decHVACCalendar">days:</label>
                  <input type="number"
                    name="decHVACCalendar"
                    min="0"
                    max="31"
                    step="1"
                    value={this.props.options.decHVACCalendar}
                    onChange={this.handleUserInput}
                  /></td>
          </tr>
          <tr>
            <td><label className="App-bold" htmlFor="janHVACHours">hrs:</label>
                  <input type="number"
                    name="janHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.janHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="febHVACHours">hrs:</label>
                  <input type="number"
                    name="febHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.febHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td>  <label className="App-bold" htmlFor="marHVACHours">hrs:</label>
                  <input type="number"
                    name="marHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.marHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="aprHVACHours">hrs:</label>
                  <input type="number"
                    name="aprHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.aprHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="mayHVACHours">hrs:</label>
                  <input type="number"
                    name="mayHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.mayHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="junHVACHours">hrs:</label>
                  <input type="number"
                    name="junHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.junHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="julHVACHours">hrs:</label>
                  <input type="number"
                    name="julHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.julHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td>  <label className="App-bold" htmlFor="augHVACHours">hrs:</label>
                  <input type="number"
                    name="augHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.augHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td><label className="App-bold" htmlFor="sepHVACHours">hrs:</label>
                  <input type="number"
                    name="sepHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.sepHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td>  <label className="App-bold" htmlFor="octHVACHours">hrs:</label>
                  <input type="number"
                    name="octHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.octHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td><label className="App-bold" htmlFor="novHVACHours">hrs:</label>
                  <input type="number"
                    name="novHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.novHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
            <td> <label className="App-bold" htmlFor="decHVACHours">hrs:</label>
                  <input type="number"
                    name="decHVACHours"
                    min="0"
                    max="24"
                    step="1"
                    value={this.props.options.decHVACHours}
                    onChange={this.handleUserInput}
                    className="number_boxes"
                  /></td>
           </tr>
        </table>
        
      </div>
    );
  }
}

export default Hvacschedule;


// WEBPACK FOOTER //
// ./src/components/Hvacschedule.js